import axios from '@api'

export default {
    getRepairReturnItem (json) {
        return axios.post(`api/maintenance/getrepairreturnitem`, json);
    },
    getRepairReturnItemById (rrId) {
        return axios.get(`api/maintenance/getrepairreturnitem/${rrId}`);
    },
    acceptMaterialEquipment (json) {
        return axios.patch(`api/maintenance/acceptmaterialequipment`, json);
    },
    rejectMaterialEquipment (rrId) {
        return axios.patch(`api/maintenance/rejectMaterialEquipment/${rrId}`);
    },
    createMaintenanceItem(form) {
        return axios.post(`api/maintenance/item`, form);
    },
    removeMaintenanceItem(id) {
        return axios.delete(`api/maintenance/item/${id}`)
    },
    submitMaintenanceItem(form) {
        return axios.patch(`api/maintenance/item/submit`, form);
    },
    submitMaintenanceItemAdjustment(form) {
        return axios.patch(`api/maintenance/item/submitadjustment`, form);
    },
    updateMaintenanceItemStatus(form) {
        return axios.patch(`api/maintenance/item/updatemaintenancestatus`, form);
    },
    getMaintenanceItemByMaintenanceId(id) {
        return axios.get(`api/maintenance/${id}/items`);
    },
    getMaintenanceItem(id) {
        return axios.get(`api/maintenance/item/${id}`);
    },
    getMaintenanceItemRepairInProgress(itemNo) {
        return axios.get(`api/maintenance/item/repairinprogress/${itemNo}`);
    },
    submitMfdInfo(form) {
        return axios.post(`api/maintenance/mfd`, form);
    },
    updateMfdInfo(form) {
        return axios.patch(`api/maintenance/mfd`, form);
    },
    maintenanceEditRmrItem(form) {
        return axios.put(`api/maintenance/returnitem`,form)
    },
    cancelMaintenanceItem(form) {
        return axios.post(`api/maintenance/cancel/maintenance`, form)
    },
    getMaintenanceAttachmentByMaintenanceId(id) {
        return axios.get(`api/maintenance/${id}/item/attachment`)
    },
    removeMaintenanceAttachment(id) {
        return axios.delete(`api/maintenance/item/attachment/${id}`)
    },
    downloadMaintenanceAttachment(id) {
        return axios.get(`api/maintenance/attachment/${id}/download`, { responseType: 'arraybuffer' })
    },
    downloadMaintenanceAttachmentByMaintenanceId(id) {
        return axios.get(`api/maintenance/${id}/attachment/download`, { responseType: 'arraybuffer' })
    },
    getMaintenanceItemInfo(maintenanceItemId) {
        return axios.get(`api/maintenance/inventoryinfo/${maintenanceItemId}`)
    },
    getFinalRefurbishList(page) {
        return axios.get(`api/maintenance/getfinalrefurbish/${page}`)
    }
}